/** Segments by grapheme rather than by index: `name[0]` splits a surrogate
 *  pair, and spreading splits clusters like flags and skin-tone modifiers. */
export const firstGrapheme = (word: string): string => {
  const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
  return segmenter.segment(word)[Symbol.iterator]().next().value?.segment ?? '';
};

/** First and last word's initials — names have unpredictable middle parts, so
 *  taking the ends beats taking the first two words. */
export const initials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const first = words[0];
  if (first === undefined) return '';

  const last = words.length > 1 ? words[words.length - 1] : undefined;
  const tail = last === undefined ? '' : firstGrapheme(last);
  return `${firstGrapheme(first)}${tail}`.toUpperCase();
};
